<template>
  <!--
    	作者：zct
    	时间：2021-10-08
    	描述：工会-添加工会
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--添加工会-->
      <div class="common-form">添加视频</div>

      <el-form-item label="标题" prop="task_title" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.task_title" placeholder="请输入工会标题" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="视频封面图片">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="活动视频" >
        <div>
          <el-button type="primary" @click="openVideoUpload">上传视频</el-button>
          <video :src="form.video_path" class="mt10" width="120px;" height="120px" v-if="isVideo" :isVideo="isVideo" controls="controls" style="display: block;" />
          <!--上传图片组件-->
          <Video v-if="isvideoupload" :config="{ total: 1 }" :isvideoupload="isvideoupload" @returnImgs="returnVideoFunc">上传视频</Video>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

  </div>
</template>

<script>

  import unitApi from '@/api/task.js';
  import Upload from '@/components/file/Upload';
  import Video from '@/components/file/Video';
  export default {
    components: {

      Upload,
      Video
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          task_title: '',
          image_id:'',
          video_id:'',
          video_path:'',
          task_id:'',

        },
        file_path: '',

        /*是否上传图片*/
        isupload: false,
        loading: false,
        isvideoupload:false,
        isVideo:false,
      };
    },
    created() {
      this.form.task_id = this.$route.query.task_id;
      /*引用的select_region 初始化*/
      this.getData();
    },

    methods: {
      getData(){

      },
      /*上传视频*/
      openVideoUpload() {
        this.isvideoupload = true;
      },
      /*获取视频*/
      returnVideoFunc(e) {
        let self = this;
        if (e != null) {
          this.form.video_id = e[0].file_id;
          this.form.video_path = e[0].file_path;
          this.isVideo = true;
        }
        this.isvideoupload = false;
      },
      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        if(!form.image_id){
          self.$message({
            message: "视频封面图片不能为空",
            type: 'error'
          });
          return false;
        }
        if(!form.video_id){
          self.$message({
            message: "视频不能为空",
            type: 'error'
          });
          return false;
        }
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            unitApi.addClock(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  self.$router.push({path:'/task/clock/index',query:{task_id:self.form.task_id}});
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });


      },

      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },



      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/task/clock/add.vue